export interface WakeLockLike {
  request(type: 'screen'): Promise<WakeLockSentinelLike>;
}

export interface WakeLockSentinelLike {
  released: boolean;
  release(): Promise<void>;
  addEventListener(type: 'release', handler: EventListener): void;
}

export class WakeLock {
  private wakeLockApi: WakeLockLike | null;
  private sentinel: WakeLockSentinelLike | null = null;
  private _isActive = false;

  constructor(deps?: { wakeLock?: WakeLockLike | null }) {
    this.wakeLockApi =
      deps?.wakeLock !== undefined
        ? deps.wakeLock
        : /* c8 ignore next */
          'wakeLock' in navigator
          ? (navigator.wakeLock as unknown as WakeLockLike)
          : null;
  }

  isSupported(): boolean {
    return this.wakeLockApi !== null;
  }

  isActive(): boolean {
    return this._isActive;
  }

  async acquire(): Promise<void> {
    if (!this.wakeLockApi || this._isActive) return;
    try {
      this.sentinel = await this.wakeLockApi.request('screen');
      this._isActive = true;
      this.sentinel.addEventListener('release', () => {
        this._isActive = false;
        this.sentinel = null;
      });
    } catch {
      this._isActive = false;
    }
  }

  async release(): Promise<void> {
    if (!this._isActive || !this.sentinel) return;
    this._isActive = false;
    const s = this.sentinel;
    this.sentinel = null;
    await s.release();
  }

  destroy(): void {
    if (this._isActive && this.sentinel) {
      this._isActive = false;
      const s = this.sentinel;
      this.sentinel = null;
      void s.release();
    }
  }
}
